import { __assign } from 'tslib';
import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Component, Input, NgModule } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { share } from 'rxjs/internal/operators';
import { EventManager } from '@angular/platform-browser';
import { DOCUMENT, CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

function NgxCheatsheetComponent_tr_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 5);
    ɵngcc0.ɵɵelementStart(2, "span", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var hotkey_r1 = ctx.$implicit;
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.formatHotkey(hotkey_r1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(hotkey_r1.description);
} }
var _c0 = function (a0) { return { "in": a0 }; };
var HOTKEY_OPTIONS = new InjectionToken('HotkeyOptions');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var _defaultOptions = {
    disableCheatSheet: false,
    cheatSheetTitle: 'Keyboard Shortcuts:',
    cheatSheetHotkey: 'shift.?',
    cheatSheetHotkeyDescription: 'Show / hide this help menu',
    cheatSheetCloseEsc: false,
    cheatSheetCloseEscDescription: 'Hide this help menu'
};
var NgxHotkeysService = /** @class */ (function () {
    function NgxHotkeysService(eventManager, config, doc) {
        var _this = this;
        this.eventManager = eventManager;
        this.config = config;
        this.registeredHotkeys = new Set();
        this.pausedHotkeys = new Set();
        this._cheatSheetToggled = new Subject();
        this.bindingSubscriptions = new Map();
        this.document = doc;
        this.defaults = { element: this.document };
        this.configuration = __assign({}, _defaultOptions, this.config);
        if (!this.configuration.disableCheatSheet) {
            this.register({
                combo: this.configuration.cheatSheetHotkey,
                handler: (/**
                 * @return {?}
                 */
                function () {
                    _this._cheatSheetToggled.next();
                }),
                description: this.configuration.cheatSheetHotkeyDescription
            });
        }
        if (this.configuration.cheatSheetCloseEsc) {
            this.register({
                combo: 'esc',
                handler: (/**
                 * @return {?}
                 */
                function () {
                    _this._cheatSheetToggled.next(false);
                }),
                description: this.configuration.cheatSheetCloseEscDescription
            });
        }
    }
    Object.defineProperty(NgxHotkeysService.prototype, "hotkeys", {
        /**
         * Returns the registered hotkeys as array.
         * @returns all registered hotkeys
         */
        get: /**
         * Returns the registered hotkeys as array.
         * @return {?} all registered hotkeys
         */
        function () {
            return Array.from(this.registeredHotkeys);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxHotkeysService.prototype, "cheatSheetToggled", {
        /**
         * Returns an Observable stream indicating the cheatsheets visibility was toggled.
         * @returns stream indicating the cheatsheets visibility was toggled
         */
        get: /**
         * Returns an Observable stream indicating the cheatsheets visibility was toggled.
         * @return {?} stream indicating the cheatsheets visibility was toggled
         */
        function () {
            return this._cheatSheetToggled.asObservable().pipe(share());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgxHotkeysService.prototype, "options", {
        /**
         * Returns the options used to configure this service.
         */
        get: /**
         * Returns the options used to configure this service.
         * @return {?}
         */
        function () {
            return this.configuration;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Registers a new hotkey/new hotkeys with it's/their handler(s).
     * @param hotkey hotkeys to listen for
     * @param unpausing flag indicating if the hotkeys should be unpaused
     */
    /**
     * Registers a new hotkey/new hotkeys with it's/their handler(s).
     * @param {?} hotkey hotkeys to listen for
     * @param {?=} unpausing flag indicating if the hotkeys should be unpaused
     * @return {?}
     */
    NgxHotkeysService.prototype.register = /**
     * Registers a new hotkey/new hotkeys with it's/their handler(s).
     * @param {?} hotkey hotkeys to listen for
     * @param {?=} unpausing flag indicating if the hotkeys should be unpaused
     * @return {?}
     */
    function (hotkey, unpausing) {
        var _this = this;
        if (unpausing === void 0) { unpausing = false; }
        /** @type {?} */
        var hotkeys = [].concat(hotkey);
        if (unpausing) {
            hotkeys = Array.from(this.pausedHotkeys);
        }
        hotkeys.forEach((/**
         * @param {?} h
         * @return {?}
         */
        function (h) {
            if (unpausing) {
                _this.pausedHotkeys.delete(h);
            }
            _this.registeredHotkeys.add(h);
            _this.bindingSubscriptions.set(h.combo, _this.bindToEventManager(h)
                .subscribe((/**
             * @return {?}
             */
            function () {
                h.handler();
            })));
        }));
    };
    /**
     * Removes a/the registered hotkey(s).
     * @param hotkey hotkey filter
     * @param pausing flag indicating if the hotkeys should be paused
     */
    /**
     * Removes a/the registered hotkey(s).
     * @param {?} hotkey hotkey filter
     * @param {?=} pausing flag indicating if the hotkeys should be paused
     * @return {?}
     */
    NgxHotkeysService.prototype.unregister = /**
     * Removes a/the registered hotkey(s).
     * @param {?} hotkey hotkey filter
     * @param {?=} pausing flag indicating if the hotkeys should be paused
     * @return {?}
     */
    function (hotkey, pausing) {
        var _this = this;
        if (pausing === void 0) { pausing = false; }
        /** @type {?} */
        var hotkeys = [].concat(hotkey);
        hotkeys.forEach((/**
         * @param {?} h
         * @return {?}
         */
        function (h) {
            _this.registeredHotkeys.delete(h);
            if (pausing) {
                _this.pausedHotkeys.add(h);
            }
            _this.unbindFromEventManager(h);
        }));
    };
    /**
     * Returns all hotkeys matching the passed combo(s).
     * @param combo combo to match against
     * @returns all matched hotkeys
     */
    /**
     * Returns all hotkeys matching the passed combo(s).
     * @param {?=} combo combo to match against
     * @return {?} all matched hotkeys
     */
    NgxHotkeysService.prototype.get = /**
     * Returns all hotkeys matching the passed combo(s).
     * @param {?=} combo combo to match against
     * @return {?} all matched hotkeys
     */
    function (combo) {
        return this.hotkeys.filter((/**
         * @param {?} h
         * @return {?}
         */
        function (h) { return h.combo === combo; }));
    };
    /**
     * Stops listening for the specified hotkeys.
     * @param hotkey hotkey filter
     */
    /**
     * Stops listening for the specified hotkeys.
     * @param {?=} hotkey hotkey filter
     * @return {?}
     */
    NgxHotkeysService.prototype.pause = /**
     * Stops listening for the specified hotkeys.
     * @param {?=} hotkey hotkey filter
     * @return {?}
     */
    function (hotkey) {
        if (!hotkey) {
            return this.pause(this.hotkeys);
        }
        /** @type {?} */
        var hotkeys = [].concat(hotkey);
        this.unregister(hotkeys, true);
    };
    /**
     * Resumes listening for the specified hotkeys.
     * @param hotkey hotkey filter
     */
    /**
     * Resumes listening for the specified hotkeys.
     * @param {?=} hotkey hotkey filter
     * @return {?}
     */
    NgxHotkeysService.prototype.unpause = /**
     * Resumes listening for the specified hotkeys.
     * @param {?=} hotkey hotkey filter
     * @return {?}
     */
    function (hotkey) {
        if (!hotkey) {
            return this.unpause(this.hotkeys);
        }
        /** @type {?} */
        var hotkeys = [].concat(hotkey);
        this.register(hotkeys, true);
    };
    /**
     * Resets all hotkeys.
     */
    /**
     * Resets all hotkeys.
     * @return {?}
     */
    NgxHotkeysService.prototype.reset = /**
     * Resets all hotkeys.
     * @return {?}
     */
    function () {
        var _this = this;
        this.registeredHotkeys.forEach((/**
         * @param {?} h
         * @return {?}
         */
        function (h) { return _this.unbindFromEventManager(h); }));
        this.registeredHotkeys.clear();
        this.pausedHotkeys.clear();
    };
    /**
     * @return {?}
     */
    NgxHotkeysService.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.reset();
    };
    /**
     * @private
     * @param {?} hotkey
     * @return {?}
     */
    NgxHotkeysService.prototype.bindToEventManager = /**
     * @private
     * @param {?} hotkey
     * @return {?}
     */
    function (hotkey) {
        var _this = this;
        /** @type {?} */
        var merged = __assign({}, this.defaults, hotkey);
        /** @type {?} */
        var event = "keydown." + merged.combo.replace('+', '.');
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        function (observer) {
            /** @type {?} */
            var handler = (/**
             * @param {?} e
             * @return {?}
             */
            function (e) {
                e.preventDefault();
                observer.next(e);
            });
            /** @type {?} */
            var dispose = _this.eventManager.addEventListener(merged.element, event, handler);
            return (/**
             * @return {?}
             */
            function () {
                dispose();
            });
        }));
    };
    /**
     * @private
     * @param {?} hotkey
     * @return {?}
     */
    NgxHotkeysService.prototype.unbindFromEventManager = /**
     * @private
     * @param {?} hotkey
     * @return {?}
     */
    function (hotkey) {
        /** @type {?} */
        var merged = __assign({}, this.defaults, hotkey);
        /** @type {?} */
        var keySub = this.bindingSubscriptions.get(merged.combo);
        if (keySub && !keySub.closed) {
            keySub.unsubscribe();
            this.bindingSubscriptions.delete(merged.combo);
        }
    };
    /** @nocollapse */
    NgxHotkeysService.ctorParameters = function () { return [
        { type: EventManager },
        { type: undefined, decorators: [{ type: Inject, args: [HOTKEY_OPTIONS,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    /** @nocollapse */ NgxHotkeysService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgxHotkeysService_Factory() { return new NgxHotkeysService(ɵɵinject(EventManager), ɵɵinject(HOTKEY_OPTIONS), ɵɵinject(DOCUMENT)); }, token: NgxHotkeysService, providedIn: "root" });
NgxHotkeysService.ɵfac = function NgxHotkeysService_Factory(t) { return new (t || NgxHotkeysService)(ɵngcc0.ɵɵinject(ɵngcc1.EventManager), ɵngcc0.ɵɵinject(HOTKEY_OPTIONS), ɵngcc0.ɵɵinject(DOCUMENT)); };
NgxHotkeysService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgxHotkeysService, factory: function (t) { return NgxHotkeysService.ɵfac(t); }, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxHotkeysService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.EventManager }, { type: undefined, decorators: [{
                type: Inject,
                args: [HOTKEY_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
    return NgxHotkeysService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxCheatsheetComponent = /** @class */ (function () {
    function NgxCheatsheetComponent(hotkeysService) {
        this.hotkeysService = hotkeysService;
        this.helpVisible = false;
        this._map = {
            meta: '\u2318',
            // ⌘
            shift: '\u21E7',
            // ⇧
            left: '\u2190',
            // ←
            right: '\u2192',
            // →
            up: '\u2191',
            // ↑
            down: '\u2193',
            // ↓
            'return': '\u23CE',
            // ⏎
            backspace: '\u232B' // ⌫
        };
        this.title = this.hotkeysService.options.cheatSheetTitle || this.title;
    }
    /**
     * @return {?}
     */
    NgxCheatsheetComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._subscription = this.hotkeysService.cheatSheetToggled
            .subscribe((/**
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) {
            if (isOpen !== false) {
                _this.hotkeys = _this.hotkeysService.hotkeys
                    .filter((/**
                 * @param {?} hotkey
                 * @return {?}
                 */
                function (hotkey) { return hotkey.description; }));
            }
            if (isOpen === false) {
                _this.helpVisible = false;
            }
            else {
                _this.toggleCheatSheet();
            }
        }));
    };
    /**
     * @param {?} hotkey
     * @return {?}
     */
    NgxCheatsheetComponent.prototype.formatHotkey = /**
     * @param {?} hotkey
     * @return {?}
     */
    function (hotkey) {
        /** @type {?} */
        var combo = Array.isArray(hotkey.combo) ? hotkey.combo[0] : hotkey.combo;
        /** @type {?} */
        var sequence = combo.split(/[\s]/);
        for (var i = 0; i < sequence.length; i++) {
            sequence[i] = this.symbolize(sequence[i]);
        }
        return sequence;
    };
    /**
     * @private
     * @param {?} combo
     * @return {?}
     */
    NgxCheatsheetComponent.prototype.symbolize = /**
     * @private
     * @param {?} combo
     * @return {?}
     */
    function (combo) {
        /** @type {?} */
        var comboSplit = combo.split('.');
        for (var i = 0; i < comboSplit.length; i++) {
            // try to resolve command / ctrl based on OS:
            if (comboSplit[i] === 'mod') {
                if (window.navigator && window.navigator.platform.indexOf('Mac') >= 0) {
                    comboSplit[i] = 'meta';
                }
                else {
                    comboSplit[i] = 'ctrl';
                }
            }
            comboSplit[i] = this._map[comboSplit[i]] || comboSplit[i];
        }
        return comboSplit.join(' + ');
    };
    /**
     * @return {?}
     */
    NgxCheatsheetComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._subscription && !this._subscription.closed) {
            this._subscription.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    NgxCheatsheetComponent.prototype.toggleCheatSheet = /**
     * @return {?}
     */
    function () {
        this.helpVisible = !this.helpVisible;
    };
    /** @nocollapse */
    NgxCheatsheetComponent.ctorParameters = function () { return [
        { type: NgxHotkeysService }
    ]; };
    NgxCheatsheetComponent.propDecorators = {
        title: [{ type: Input }]
    };
NgxCheatsheetComponent.ɵfac = function NgxCheatsheetComponent_Factory(t) { return new (t || NgxCheatsheetComponent)(ɵngcc0.ɵɵdirectiveInject(NgxHotkeysService)); };
NgxCheatsheetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxCheatsheetComponent, selectors: [["ngx-cheatsheet"]], inputs: { title: "title" }, decls: 9, vars: 5, consts: [[1, "ngx-cheatsheet", "fade", 2, "display", "none", 3, "ngClass"], [1, "ngx-cheatsheet__hotkeys"], [1, "ngx-cheatsheet__hotkeys__title"], [4, "ngFor", "ngForOf"], [1, "ngx-cheatsheet__hotkeys__close", 3, "click"], [1, "ngx-cheatsheet__hotkeys__keys"], [1, "ngx-cheatsheet__hotkeys__keys__key"], [1, "ngx-cheatsheet__hotkeys__keys__text"]], template: function NgxCheatsheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h4", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "table");
        ɵngcc0.ɵɵelementStart(5, "tbody");
        ɵngcc0.ɵɵtemplate(6, NgxCheatsheetComponent_tr_6_Template, 6, 2, "tr", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵlistener("click", function NgxCheatsheetComponent_Template_div_click_7_listener() { return ctx.toggleCheatSheet(); });
        ɵngcc0.ɵɵtext(8, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx.helpVisible));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hotkeys);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgForOf], styles: [".ngx-cheatsheet[_ngcontent-%COMP%]{display:table!important;position:fixed;width:100%;height:100%;top:0;left:0;color:#333;font-size:1em;background-color:rgba(255,255,255,.9)}.ngx-cheatsheet.fade[_ngcontent-%COMP%]{z-index:-1024;visibility:hidden;opacity:0;transition:opacity .15s linear}.ngx-cheatsheet.fade.in[_ngcontent-%COMP%]{z-index:10002;visibility:visible;opacity:1}.ngx-cheatsheet__hotkeys[_ngcontent-%COMP%]{width:100%;height:100%;display:table-cell;vertical-align:middle}.ngx-cheatsheet__hotkeys__title[_ngcontent-%COMP%]{font-weight:700;text-align:center;font-size:1.2em}.ngx-cheatsheet__hotkeys[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{margin:auto;color:#333}.ngx-cheatsheet__hotkeys__keys[_ngcontent-%COMP%]{padding:5px;text-align:right}.ngx-cheatsheet__hotkeys__keys__key[_ngcontent-%COMP%]{display:inline-block;color:#fff;background-color:#333;border:1px solid #333;border-radius:5px;text-align:center;margin-right:5px;box-shadow:inset 0 1px 0 #666,0 1px 0 #bbb;padding:5px 9px;font-size:1em}.ngx-cheatsheet__hotkeys__keys__text[_ngcontent-%COMP%]{padding-left:10px;font-size:1em}.ngx-cheatsheet__hotkeys__close[_ngcontent-%COMP%]{position:fixed;top:20px;right:20px;font-size:2em;font-weight:700;padding:5px 10px;border:1px solid #ddd;border-radius:5px;min-height:45px;min-width:45px;text-align:center;cursor:pointer}@media all and (max-width:500px){.ngx-cheatsheet__hotkeys[_ngcontent-%COMP%]{font-size:.8em}}@media all and (min-width:750px){.ngx-cheatsheet__hotkeys[_ngcontent-%COMP%]{font-size:1.2em}}"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxCheatsheetComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-cheatsheet',
                template: "<div class=\"ngx-cheatsheet fade\" [ngClass]=\"{'in': helpVisible}\" style=\"display:none\">\r\n  <div class=\"ngx-cheatsheet__hotkeys\">\r\n    <h4 class=\"ngx-cheatsheet__hotkeys__title\">{{ title }}</h4>\r\n    <table>\r\n      <tbody>\r\n        <tr *ngFor=\"let hotkey of hotkeys\">\r\n          <td class=\"ngx-cheatsheet__hotkeys__keys\">\r\n            <span class=\"ngx-cheatsheet__hotkeys__keys__key\">{{ formatHotkey(hotkey) }}</span>\r\n          </td>\r\n          <td class=\"ngx-cheatsheet__hotkeys__keys__text\">{{ hotkey.description }}</td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n    <div class=\"ngx-cheatsheet__hotkeys__close\" (click)=\"toggleCheatSheet()\">&#215;</div>\r\n  </div>\r\n</div>",
                styles: [".ngx-cheatsheet{display:table!important;position:fixed;width:100%;height:100%;top:0;left:0;color:#333;font-size:1em;background-color:rgba(255,255,255,.9)}.ngx-cheatsheet.fade{z-index:-1024;visibility:hidden;opacity:0;transition:opacity .15s linear}.ngx-cheatsheet.fade.in{z-index:10002;visibility:visible;opacity:1}.ngx-cheatsheet__hotkeys{width:100%;height:100%;display:table-cell;vertical-align:middle}.ngx-cheatsheet__hotkeys__title{font-weight:700;text-align:center;font-size:1.2em}.ngx-cheatsheet__hotkeys table{margin:auto;color:#333}.ngx-cheatsheet__hotkeys__keys{padding:5px;text-align:right}.ngx-cheatsheet__hotkeys__keys__key{display:inline-block;color:#fff;background-color:#333;border:1px solid #333;border-radius:5px;text-align:center;margin-right:5px;box-shadow:inset 0 1px 0 #666,0 1px 0 #bbb;padding:5px 9px;font-size:1em}.ngx-cheatsheet__hotkeys__keys__text{padding-left:10px;font-size:1em}.ngx-cheatsheet__hotkeys__close{position:fixed;top:20px;right:20px;font-size:2em;font-weight:700;padding:5px 10px;border:1px solid #ddd;border-radius:5px;min-height:45px;min-width:45px;text-align:center;cursor:pointer}@media all and (max-width:500px){.ngx-cheatsheet__hotkeys{font-size:.8em}}@media all and (min-width:750px){.ngx-cheatsheet__hotkeys{font-size:1.2em}}"]
            }]
    }], function () { return [{ type: NgxHotkeysService }]; }, { title: [{
            type: Input
        }] }); })();
    return NgxCheatsheetComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxHotkeysModule = /** @class */ (function () {
    function NgxHotkeysModule() {
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    NgxHotkeysModule.forRoot = /**
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        return {
            ngModule: NgxHotkeysModule,
            providers: [
                NgxHotkeysService,
                {
                    provide: HOTKEY_OPTIONS,
                    useValue: options
                }
            ]
        };
    };
NgxHotkeysModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxHotkeysModule });
NgxHotkeysModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxHotkeysModule_Factory(t) { return new (t || NgxHotkeysModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxHotkeysModule, { declarations: function () { return [NgxCheatsheetComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxCheatsheetComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxHotkeysModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxCheatsheetComponent
                ],
                exports: [
                    NgxCheatsheetComponent
                ]
            }]
    }], function () { return []; }, null); })();
    return NgxHotkeysModule;
}());

export { NgxCheatsheetComponent, NgxHotkeysModule, NgxHotkeysService, HOTKEY_OPTIONS as ɵa };

//# sourceMappingURL=balticcode-ngx-hotkeys.js.map